// extracted by mini-css-extract-plugin
module.exports = {"footer":"footer_footer__jsu1O","helpLink":"footer_helpLink__113jm"};